// src/components/DynamicTable/productRestriction/components/RatePlanRestrictions.js

import React, { useState, memo, useMemo, useEffect, useCallback, useContext, useRef } from 'react';
import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, IconButton, Box, Chip, Tooltip, Popover
} from '@mui/material';
import UpdateRestrictionsProductModal from '../../../Modal/UpdateRestrictionsProductModal'
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import "../style.css";
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import moment from 'moment';

import { RowDataContext, RatePlanRowDataContext, RestrictionsStateContext, RestrictionsMainDataContext } from '../contexts';
import RestrictionCopyMenu from '../RestrictionCopyMenu';
import { anyRatePlanHasOverriden, isAnyRestrictionsAltered, compareBuckets } from '../functions';
import Skeleton from '@mui/material/Skeleton';
import { callApiDirect } from "../../../../hooks/useFetchApi";



export const RatePlanRestrictions = ({ data, compId, roomTypeCode, bucketIndex, ratePlanIndex, roomTypeIndex, ratePlanCode, type, cellStyle, itemCounts, roomTypeCounts }) => {
    const showCopyDown = type == 'bucket' ? itemCounts > bucketIndex + 1 : itemCounts > ratePlanIndex + 1;
    const showCopyRight = roomTypeCounts > roomTypeIndex + 1;
    const dispatch = useDispatch();

    const appState = useSelector((state) => state);
    const { current_property_date } = appState?.auth?.profile;
    const { app_state } = appState?.app?.current_state;
    const { plrFeatures, as_of_date } = app_state;

    // const { currency_symbol } = ui_state;
    const ratePlanRowData = useContext(RatePlanRowDataContext);
    const restrictionsState = useContext(RestrictionsStateContext);

    // const [bucketRecAcceptStatus, setBucketRecAcceptStatus] = useState(data.recommended_accepted);

    //For Restrictions
    const mainData = useContext(RestrictionsMainDataContext);
    const rowData = useContext(RowDataContext);
    const indexOfRow = mainData?.data?.findIndex(item => item.date === rowData.data.date);
    // const ratePlanRowData = useContext(RatePlanRowDataContext);
    let roomData = data;
    // rowData.data.recalculating = true;
    // if (type === 'bucket') roomData = rowData.data.buckets[bucketIndex]?.rooms_summary.find(itm => itm.room_type_code === roomTypeCode);
    // if (type === 'rate_plan') roomData = rowData.data.buckets[bucketIndex].rate_plans[ratePlanIndex].room_summary.find(itm => itm.room_type_code === roomTypeCode);

    const compRef = useRef({ buckets: rowData.data.buckets });
    const updateCompRef = (delta = {}) => {
        if (compRef?.current) compRef.current = { ...compRef.current, ...delta };
    }

    const isRoomTypeSupported = Boolean(roomData?.room_type_supported || roomData?.restrictions); // Ensure it's a boolean

    const hasRestrictions = Boolean(roomData?.restrictions);
    const anyRestrictions = Boolean(hasRestrictions && (roomData?.restrictions.current.length || roomData?.restrictions.recommended.length || roomData?.restrictions.user_override.length));
    let hasCurrent = Boolean(hasRestrictions && roomData?.restrictions.current.length);
    const hasRecommended = () => {
        return plrFeatures.restrictionsRec && Boolean(roomData?.restrictions?.recommended?.length);
    }
    const isPrevUserOverriden = () => roomData?.prev_user_action === 'overridden';;
    const isRestrictionOverriden = () => roomData?.curr_user_action === 'overridden';
    const isRecommendedAccepted = () => roomData?.curr_user_action === 'recommended_accepted'

    const currentRestrictions = roomData?.restrictions?.current || [];

    // if(type ==='rate_plan' && roomData.room_type_code === 'TB') debugger;

    // roomData.restrictions.user_override = useMemo(() => _.cloneDeep(roomData?.restrictions?.current));
    if (!roomData?.restrictions?.user_override.length) {
        //roomData.restrictions.user_override = _.cloneDeep(roomData?.restrictions?.current);
    }
    const [recAcceptStatus, setRecAcceptStatus] = useState(isRecommendedAccepted());
    const [overriddenStatus, setOverriddenStatus] = useState(isRestrictionOverriden());
    let [displayValue, setDisplayValue] = useState(roomData?.restrictions?.user_override || []);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [toolTipOpen, setToolTipOpen] = useState(null);
    const [showCopyMenu, setShowCopyMenu] = React.useState(false);

    const [transition, setTransition] = useState(type === 'rate_plan' ? true : false);
    
    function markRestrictionsUpdate(overriddenStatus) {
        // restrictionsState.updateState({ rowRestrictionsUpdated: data.room_type_code + '_' + moment().format("x") });
        rowData.data.bucket_update = true;
        let isAnyRestrictionsChanged = isAnyRestrictionsAltered(rowData.data.buckets);// anyRatePlanHasOverriden(rowData.data.buckets);
        let isAnyOverridden = compareBuckets(compRef.current.buckets);
        // console.log(isAnyOverridden, 'compareBuckets', compRef.current.buckets, rowData.data.buckets);
        // debugger;
        rowData.data.isRestrictionsOverridden = isAnyOverridden; //overriddenStatus; //isAnyOverridden;

        rowData.data.processing = false;
        rowData.data.thresholdRecalc = null;
        // rowData.updateRowData(rowData.data);

        restrictionsState.updateState({
            rowRestrictionsUpdated: data.room_type_code + '_' + moment().format("x"),
            // recalcStatus: {date: isAnyOverridden ? rowData.data.date : null , status: isAnyOverridden ? 'active' : null}
        });


        dispatch({
            type: "UPDATE_STATE",
            payload: {
                app_state: {
                    // plrDatesToPush: plrDatesToPush,
                    plrRowCalcStatus: isAnyOverridden ? 'active' : null, //isAnyOverridden ? 'active' : null,
                    plrRecalcDate: isAnyOverridden ? rowData.data.date : null //isAnyOverridden ? rowData.data.date : null,
                }
            }
        });
    }

    const getEntryTransformed = () => {
        let entry = {};
        try {
            if (isRecommendedAccepted()) {
                roomData.restrictions.user_override = _.cloneDeep(roomData?.restrictions?.recommended);
            }
            if (isRestrictionOverriden()) {
                roomData.restrictions.user_override = _.cloneDeep(roomData?.restrictions?.user_override);
            }
            if (!isRestrictionOverriden() && !isRecommendedAccepted()) {
                roomData.restrictions.user_override = _.cloneDeep(roomData?.restrictions?.current);
            }
            roomData?.restrictions?.user_override?.forEach((item) => {
                if (['CTA', 'CTD'].includes(item)) {
                    entry[item.toLowerCase()] = true;
                }
                if (item.includes('CLS')) {
                    entry['close'] = true;
                }
                if (item.includes('MN ')) {
                    let value = item.split(' ')[1];
                    entry['min_los'] = Number(value);
                }
                if (item.includes('MX ')) {
                    let value = item.split(' ')[1];
                    entry['max_los'] = Number(value);
                }
            });
            return entry;
        } catch (e) {
            console.error("Error in getEntryTransformed:", e);
        }
    };

    const entryInitial = getEntryTransformed();

    const [compState, setCompState] = useState({
        modalOpen: false,
        open: !entryInitial?.cta && !entryInitial?.ctd && !entryInitial?.close ? true : false,
        entryFields: [],
        entry: {
            cta: false,
            ctd: false,
            close: false,
            open: true,
            min_los: '',
            max_los: '',
            exceptions: {},
            ...entryInitial, // Initialize with the entryInitial object
        },
    });

    const { modalOpen } = compState;
    const isPastDate = moment(rowData.data.date).isBefore(moment().format("YYYY-MM-DD"));
    const isPastAsOfDate = moment(as_of_date).isBefore(current_property_date);

    const handleModalClose = useCallback((data, isChanged) => {
        if (!isChanged) {
            setCompState(state => {
                return { ...state, modified: false, modalOpen: false };
            });
        } else {
            setDisplayValue(roomData.restrictions.user_override || []);
            setCompState(state => {
                return { ...state, entry: { ...state.entry, open: false }, modified: false, modalOpen: false };
            });

            if (roomData.restrictions.user_override.length && displayValue.join() !== roomData.restrictions.user_override.join()) {
                if (type === 'bucket') {
                    rowData.data.buckets[bucketIndex].rooms_summary[roomTypeIndex].restrictions.user_override = _.cloneDeep(roomData.restrictions.user_override);
                    if (data?.restrictions?.user_override?.length) {
                        let user = data?.restrictions?.user_override.join();
                        let rec = data?.restrictions?.recommended.join();
                        let curr = data?.restrictions?.current.join();
                        let curr_user_action = '';

                        if (user && user !== curr && user !== rec) {
                            curr_user_action = 'overridden';
                        } else if (user === rec) {
                            curr_user_action = 'recommended_accepted';
                        }

                        rowData.data.buckets[bucketIndex].curr_user_action = curr_user_action;
                    }
                } else {

                    const indexOfRoomTypeCode = rowData.data.buckets[bucketIndex].rate_plans[ratePlanIndex].rooms_summary.findIndex(roomSummary => roomSummary.room_type_code === roomTypeCode);
                    if (indexOfRoomTypeCode > -1) {
                        rowData.data.buckets[bucketIndex].rate_plans[ratePlanIndex].rooms_summary[indexOfRoomTypeCode].restrictions.user_override = _.cloneDeep(data.restrictions.user_override);
                    }
                    if (data?.restrictions?.user_override?.length) {
                        // rowData.data.buckets[bucketIndex].rate_plans[ratePlanIndex].rooms_summary[roomTypeIndex].curr_user_action = 'overridden';
                        let user = data?.restrictions?.user_override.join();
                        let rec = data?.restrictions?.recommended.join();
                        let curr = data?.restrictions?.current.join();
                        let curr_user_action = '';
                        if (user && user !== curr && user !== rec) {
                            curr_user_action = 'overridden';
                        } else if (user === rec) {
                            curr_user_action = 'recommended_accepted';
                        }
                        if (indexOfRoomTypeCode > -1) {
                            rowData.data.buckets[bucketIndex].rate_plans[ratePlanIndex].rooms_summary[indexOfRoomTypeCode].curr_user_action = curr_user_action;
                        }
                    }
                }

                rowData.updateRowData(rowData.data);
                // mainData.data[indexOfRow] = _.cloneDeep(rowData.data);
                // mainData.updateData(mainData.data);

                setTimeout(() => {
                    setShowCopyMenu(true);
                }, 500);
            }

            if (!roomData.restrictions.user_override.length) {
                let user = roomData?.restrictions?.user_override.join();
                let curr = roomData?.restrictions?.current.join();
                let curr_user_action = '';
                if (type === 'bucket') {
                    if ((curr && !user) || user !== curr) {
                        roomData.curr_user_action = 'overridden';
                    }
                } else {
                    if ((curr && !user) || user !== curr) {
                        roomData.curr_user_action = 'overridden';
                    }
                }

                //Commenting untill real data is coming from API
                // rowData.data.buckets[bucketIndex].rate_plans.forEach(rate_plan => {
                //     rate_plan.rooms_summary[roomTypeIndex].restrictions.user_override = [];
                //     rate_plan.rooms_summary[roomTypeIndex].curr_user_action = 'overridden';
                // })
            }
            //checking if bucket restriction has been changed
            // let isoverridden = Boolean(data?.restrictions?.user_override?.length);
            markRestrictionsUpdate(isChanged);
        }
    });

    const handleCurrentRestrictionsClick = () => {
        if (isPastDate || isPastAsOfDate) return;
        if (rowData.data.processing || rowData.data.recalculating) return;

        let newEntry = getEntryTransformed();
        Object.keys(compState.entry).forEach((key) => {
            if (['cta', 'ctd', 'close'].includes(key) && compState.entry[key] && !newEntry[key]) {
                newEntry[key] = false;
            }
            if (['min_los', 'max_los'].includes(key) && compState.entry[key] && !newEntry[key]) {
                //newEntry[key] = 1;
                newEntry[key] = "";
            }
        });
        setCompState(state => {
            return { ...state, entry: { ...state.entry, ...newEntry }, modalOpen: true };
        })
        // markRestrictionsUpdate(false);
    }
    const handleRecommededRestrictionsClick = (e) => {
        if (rowData.data.processing || rowData.data.recalculating) return;
        e.preventDefault();
        e.stopPropagation();
        const roomTypeCode = roomData?.room_type_code;
        roomData.restrictions.user_override = _.cloneDeep(roomData.restrictions.recommended);
        roomData.curr_user_action = "recommended_accepted";
        const isRecAccepted = roomData.curr_user_action === 'recommended_accepted';
        setDisplayValue(roomData.restrictions.user_override);

        let newEntry = getEntryTransformed();
        Object.keys(compState.entry).forEach((key) => {
            if (['cta', 'ctd', 'close'].includes(key) && compState.entry[key] && !newEntry[key]) {
                newEntry[key] = false;
            }
            if (['min_los', 'max_los'].includes(key) && compState.entry[key] && !newEntry[key]) {
                //newEntry[key] = 1;
                newEntry[key] = "";
            }
        });
        setCompState(state => {
            return { ...state, entry: { ...state.entry, ...newEntry } };
        })

        if (type === 'bucket' && rowData.data?.buckets?.length) {
            const newRowData = rowData.data?.buckets[bucketIndex];
            // const isRecAccepted = newRowData.rooms_summary[roomTypeIndex].curr_user_action === 'recommended_accepted';

            //Make changes to ratePlanRowData rate plan restrictions
            ratePlanRowData.rate_plans.forEach((ratePlan) => {
                const indexOfRoomTypeCode = ratePlan.rooms_summary.findIndex(roomSummary => roomSummary.room_type_code === roomTypeCode);
                const ratePlanRoomData = ratePlan.rooms_summary[indexOfRoomTypeCode];
                // const { room_type_supported } = ratePlan?.rooms_summary[indexOfRoomTypeCode]
                if (roomData.restrictions) {
                    // ratePlan.rec_accepted = roomData.rec_accepted;
                    if (ratePlanRoomData?.restrictions.recommended.length) {
                        ratePlanRoomData.curr_user_action = "recommended_accepted";
                        ratePlanRoomData.restrictions.user_override = _.cloneDeep(ratePlanRoomData.restrictions.recommended);
                    }
                }
            });

            rowData.data.bucket_update += rowData.data.bucket_update ? rowData.data.bucket_update : 1;

        }
        rowData.updateRowData(rowData.data);
        setRecAcceptStatus(isRecAccepted);
        //checking if bucket restriction has been changed
        markRestrictionsUpdate(false);
    }

    const jsx_editRestrictionPopup = <UpdateRestrictionsProductModal
        roomData={roomData}
        modalOpen={modalOpen}
        handleModalClose={handleModalClose}
        compState={compState}
        setCompState={setCompState} />;

    let jsx_addRestrictions = <Box onClick={handleCurrentRestrictionsClick} className='cur-restrictions'>
        <Box className='add-res-btn'>
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 0C3.20888 0 2.43552 0.234596 1.77772 0.674121C1.11992 1.11365 0.607234 1.73836 0.304484 2.46927C0.00173314 3.20017 -0.0774802 4.00444 0.0768607 4.78036C0.231202 5.55628 0.612164 6.26902 1.17157 6.82843C1.73098 7.38784 2.44372 7.7688 3.21964 7.92314C3.99556 8.07748 4.79983 7.99827 5.53073 7.69552C6.26164 7.39277 6.88635 6.88008 7.32588 6.22228C7.7654 5.56448 8 4.79112 8 4C7.99868 2.93954 7.57682 1.92289 6.82697 1.17303C6.07711 0.423175 5.06046 0.0013231 4 0ZM5.53846 4.30769H4.30769V5.53846C4.30769 5.62007 4.27528 5.69833 4.21757 5.75603C4.15987 5.81374 4.08161 5.84615 4 5.84615C3.9184 5.84615 3.84013 5.81374 3.78243 5.75603C3.72473 5.69833 3.69231 5.62007 3.69231 5.53846V4.30769H2.46154C2.37993 4.30769 2.30167 4.27527 2.24397 4.21757C2.18626 4.15987 2.15385 4.0816 2.15385 4C2.15385 3.91839 2.18626 3.84013 2.24397 3.78243C2.30167 3.72472 2.37993 3.69231 2.46154 3.69231H3.69231V2.46154C3.69231 2.37993 3.72473 2.30167 3.78243 2.24397C3.84013 2.18626 3.9184 2.15385 4 2.15385C4.08161 2.15385 4.15987 2.18626 4.21757 2.24397C4.27528 2.30167 4.30769 2.37993 4.30769 2.46154V3.69231H5.53846C5.62007 3.69231 5.69833 3.72472 5.75603 3.78243C5.81374 3.84013 5.84615 3.91839 5.84615 4C5.84615 4.0816 5.81374 4.15987 5.75603 4.21757C5.69833 4.27527 5.62007 4.30769 5.53846 4.30769Z" fill="#B2B2B2" />
            </svg>

            <Box>Add {!hasCurrent && hasRecommended() ? '' : ' Restrictions'}</Box>
        </Box>
    </Box>;
    if (isPastAsOfDate) {
        jsx_addRestrictions = <Box onClick={handleCurrentRestrictionsClick} className='cur-restrictions pas-asof'>
            <Tooltip title="Please set the “As of date” to the current date to update the Restrictions." arrow>
                <Box className='add-res-btn'>
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 0C3.20888 0 2.43552 0.234596 1.77772 0.674121C1.11992 1.11365 0.607234 1.73836 0.304484 2.46927C0.00173314 3.20017 -0.0774802 4.00444 0.0768607 4.78036C0.231202 5.55628 0.612164 6.26902 1.17157 6.82843C1.73098 7.38784 2.44372 7.7688 3.21964 7.92314C3.99556 8.07748 4.79983 7.99827 5.53073 7.69552C6.26164 7.39277 6.88635 6.88008 7.32588 6.22228C7.7654 5.56448 8 4.79112 8 4C7.99868 2.93954 7.57682 1.92289 6.82697 1.17303C6.07711 0.423175 5.06046 0.0013231 4 0ZM5.53846 4.30769H4.30769V5.53846C4.30769 5.62007 4.27528 5.69833 4.21757 5.75603C4.15987 5.81374 4.08161 5.84615 4 5.84615C3.9184 5.84615 3.84013 5.81374 3.78243 5.75603C3.72473 5.69833 3.69231 5.62007 3.69231 5.53846V4.30769H2.46154C2.37993 4.30769 2.30167 4.27527 2.24397 4.21757C2.18626 4.15987 2.15385 4.0816 2.15385 4C2.15385 3.91839 2.18626 3.84013 2.24397 3.78243C2.30167 3.72472 2.37993 3.69231 2.46154 3.69231H3.69231V2.46154C3.69231 2.37993 3.72473 2.30167 3.78243 2.24397C3.84013 2.18626 3.9184 2.15385 4 2.15385C4.08161 2.15385 4.15987 2.18626 4.21757 2.24397C4.27528 2.30167 4.30769 2.37993 4.30769 2.46154V3.69231H5.53846C5.62007 3.69231 5.69833 3.72472 5.75603 3.78243C5.81374 3.84013 5.84615 3.91839 5.84615 4C5.84615 4.0816 5.81374 4.15987 5.75603 4.21757C5.69833 4.27527 5.62007 4.30769 5.53846 4.30769Z" fill="#B2B2B2" />
                    </svg>

                    <Box>Add {!hasCurrent && hasRecommended() ? '' : ' Restrictions'}</Box>
                </Box>
            </Tooltip>
        </Box>;
    }

    let jsx_current = (showPasdatemsg = true) => {
        // if(!displayValue.length) return '';
        //Added fix for now showing MN 1 value
        if (displayValue.includes('MN 1')) {
            const indexOfMn1 = displayValue.indexOf('MN 1');
            displayValue.splice(indexOfMn1, 1);
        }
        if (isPastAsOfDate && showPasdatemsg) {
            return <Tooltip title="Please set the “As of date” to the current date to update the Restrictions." arrow>
                <Box sx={{ display: 'inline' }}>
                    <Box className='cur-restrictions past-date' onClick={handleCurrentRestrictionsClick}>
                        {displayValue.length && displayValue.slice(0, 2).map((r, i) => (
                            <Chip key={i} className={`restrictions-chips chip-${r.toLowerCase()}`} label={r} variant="outlined" />
                        ))}
                    </Box>
                    {!isPastAsOfDate && displayValue.length && <RestrictionCopyMenu showCopyDown={showCopyDown} showCopyRight={showCopyRight} bucketIndex={bucketIndex} ratePlanIndex={ratePlanIndex} roomTypeIndex={roomTypeIndex} data={roomData} onCloseHandler={() => { setShowCopyMenu(false) }} openCopyBtn={true} markRestrictionsUpdate={markRestrictionsUpdate} />}
                </Box>
                <Box>
                    {(displayValue.length > 2) && <RestrictionsToolTip
                        ratePlanCode={ratePlanCode}
                        roomTypeCode={roomData?.room_type_code}
                        isRestrictionsRoomType={true}
                        chipArrAll={displayValue || []}
                        restrictionHouseData={{}}
                        roomTypeRestdata={displayValue}
                        toolTipOpen={toolTipOpen}
                        openToolTip={(event) => {
                            setAnchorEl(null);
                            // setToolTipOpen(true);
                            setShowCopyMenu(false);
                        }}
                        closeToolTip={(event) => {
                            // setAnchorEl(null)
                            // setToolTipOpen(false);
                        }}
                        setAnchorEl={setAnchorEl}
                        anchorEl={anchorEl}
                    />}
                </Box>
            </Tooltip>;
        }
        if(!displayValue.length){
            return <>
                {!isPastAsOfDate && !isPastDate && showCopyMenu && <RestrictionCopyMenu showCopyDown={showCopyDown} showCopyRight={showCopyRight} bucketIndex={bucketIndex} ratePlanIndex={ratePlanIndex} roomTypeIndex={roomTypeIndex} data={roomData} onCloseHandler={() => { setShowCopyMenu(false) }} openCopyBtn={true} markRestrictionsUpdate={markRestrictionsUpdate} />}
            </>
        }
        return <>
            <Box sx={{ display: 'inline' }}>
               <Box className='cur-restrictions'>
                    {displayValue.length && displayValue.slice(0, 2).map((r, i) => (
                        <Chip key={i} className={`restrictions-chips chip-${r.toLowerCase()}`} label={r} variant="outlined" />
                    ))}
                </Box>
                {!isPastDate && showCopyMenu && <RestrictionCopyMenu showCopyDown={showCopyDown} showCopyRight={showCopyRight} bucketIndex={bucketIndex} ratePlanIndex={ratePlanIndex} roomTypeIndex={roomTypeIndex} data={roomData} onCloseHandler={() => { setShowCopyMenu(false) }} openCopyBtn={true} markRestrictionsUpdate={markRestrictionsUpdate} />}
            </Box>
            
                {(displayValue.length > 2) && <Box> <RestrictionsToolTip
                    ratePlanCode={ratePlanCode}
                    roomTypeCode={roomData?.room_type_code}
                    isRestrictionsRoomType={true}
                    chipArrAll={displayValue || []}
                    restrictionHouseData={{}}
                    roomTypeRestdata={displayValue}
                    toolTipOpen={toolTipOpen}
                    openToolTip={(event) => {
                        setAnchorEl(null);
                        // setToolTipOpen(true);
                        setShowCopyMenu(false);
                    }}
                    closeToolTip={(event) => {
                        // setAnchorEl(null)
                        // setToolTipOpen(false);
                    }}
                    setAnchorEl={setAnchorEl}
                    anchorEl={anchorEl}
                /></Box>}
            
        </>;
    }

    const jsx_current_strikedoff = <>
        <Box className='cur-restrictions striked-off'>
            {currentRestrictions.map((r, i) => (
                <Chip key={i} className={`restrictions-chips removed chip-${r.toLowerCase()}`} label={r} variant="outlined" />
            ))}
        </Box>
    </>;

    const jsx_recommended = <>

        {/* SVG separator */}
        <svg width="2" height="14" viewBox="0 0 2 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 0V14" stroke="url(#paint0_linear_1510_45063)" />
            <defs>
                <linearGradient id="paint0_linear_1510_45063" x1="1.5" y1="0" x2="1.5" y2="14" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="0.495192" stopColor="#B2B2B2" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
            </defs>
        </svg>
        <Box className='rec-restrictions' onClick={handleRecommededRestrictionsClick}>
            <div className='rec-text'>Rec:</div>
            {roomData?.restrictions?.recommended.map((r, i) => (
                <Chip key={i} className={`restrictions-chips chip-${r.toLowerCase()}`} label={r} variant="outlined" />
            ))}
        </Box>
    </>;


    useEffect(() => {
        if (roomData && roomData.curr_user_action === 'overridden' && roomData?.restrictions?.user_override.length) {
            //Added fix for now showing MN 1 value
            if (roomData?.restrictions?.user_override.includes('MN 1')) {
                const indexOfMn1 = roomData?.restrictions?.user_override.indexOf('MN 1');
                roomData?.restrictions?.user_override.splice(indexOfMn1, 1);
            }
            setDisplayValue(_.cloneDeep(roomData.restrictions.user_override));
            isRestrictionOverriden(true)
        }
        if (roomData && roomData.curr_user_action === 'recommended_accepted' && roomData?.restrictions?.recommended.length) {
            setDisplayValue(_.cloneDeep(roomData.restrictions.user_override));
            isRecommendedAccepted(true)
        }
        if (roomData && roomData.curr_user_action === '' && roomData?.restrictions?.current.length) {
            setDisplayValue(_.cloneDeep(roomData.restrictions.user_override));
            isRecommendedAccepted(false)
            isRestrictionOverriden(false)
        }
        //Cleaning up
        return () => {
            // if(data.copy_row_count) delete data.copy_row_count
        }
    }, []);

    useEffect(() => {
        if (restrictionsState.state.rowRestrictionsUpdated) {
            const roomTypeCode = restrictionsState.state.rowRestrictionsUpdated.split('_')[0];

            //Added fix for now showing MN 1 value
            if (roomData?.restrictions?.user_override.includes('MN 1')) {
                const indexOfMn1 = roomData?.restrictions?.user_override.indexOf('MN 1');
                roomData?.restrictions?.user_override.splice(indexOfMn1, 1);
            }

            if (roomData?.room_type_code === roomTypeCode) {
                if (roomData && roomData.curr_user_action === 'recommended_accepted') {
                    if (roomData?.restrictions?.recommended.length) {
                        setDisplayValue(_.cloneDeep(roomData.restrictions.user_override));
                    } else {
                        setDisplayValue(_.cloneDeep(roomData.restrictions.user_override));
                    }
                    isRecommendedAccepted(true)
                } else if (roomData && roomData.curr_user_action === 'overridden') {
                    setDisplayValue(_.cloneDeep(roomData.restrictions.user_override));
                    isRestrictionOverriden(true);
                } else {
                    setDisplayValue(_.cloneDeep(roomData.restrictions.user_override));
                    isRestrictionOverriden(false);
                    isRecommendedAccepted(false);
                }
            }
        }

        //Cleaning up
        return () => {
            // if(data.copy_row_count) delete data.copy_row_count
        }
    }, [restrictionsState.state.rowRestrictionsUpdated]);

    useEffect(() => {
        // let isRecAccepted = isRecommendedAccepted(); //data.curr_user_action === 'recommended_accepted';
        if (roomData && rowData.data.rowUpdated) {
            setRecAcceptStatus(false);
            setOverriddenStatus(false);

            //Added fix for now showing MN 1 value
            if (roomData?.restrictions?.user_override.includes('MN 1')) {
                const indexOfMn1 = roomData?.restrictions?.user_override.indexOf('MN 1');
                roomData?.restrictions?.user_override.splice(indexOfMn1, 1);
            }
            if (rowData.data.threshold.curr_user_action === 'recommended_accepted') {
                setRecAcceptStatus(true);
                setOverriddenStatus(false);
                roomData.curr_user_action = "recommended_accepted";
                roomData.restrictions.user_override = _.cloneDeep(roomData.restrictions.recommended);
                setDisplayValue(roomData.restrictions.user_override);
            }
            if (rowData.data.threshold.curr_user_action === 'overridden') {
                setRecAcceptStatus(false);
                setOverriddenStatus(true);
                //roomData.curr_user_action = "overridden";
                displayValue = roomData.restrictions.user_override;
                setDisplayValue(_.cloneDeep(roomData.restrictions.user_override));
            }
            if (rowData.data.threshold.curr_user_action === '') {
                setDisplayValue(_.cloneDeep(roomData.restrictions.user_override));
                if (roomData.curr_user_action === 'overridden') {
                    setOverriddenStatus(true);
                    displayValue = roomData.restrictions.user_override;
                    setDisplayValue(_.cloneDeep(roomData.restrictions.user_override));
                }
                if (roomData.curr_user_action === 'recommended_accepted') {
                    setRecAcceptStatus(false);
                    displayValue = roomData.restrictions.recommended;
                    setDisplayValue(_.cloneDeep(roomData.restrictions.recommended));
                }
                if (roomData.curr_user_action === '') {
                    setOverriddenStatus(true);
                    displayValue = roomData.restrictions.user_override;
                    setDisplayValue(_.cloneDeep(roomData.restrictions.user_override));
                }
            }
            // rowData.data.rowUpdated = null;
            // rowData.updateRowData(rowData.data);
        }

    }, [rowData.data.rowUpdated]);


    useEffect(() => {
        if (data?.copy_row_count && roomData?.restrictions) {
            setDisplayValue(_.cloneDeep(roomData.restrictions.user_override));
            delete data.copy_row_count
        }
        //Cleaning up
        return () => {
            // if(data.copy_row_count) delete data.copy_row_count
        }
    }, [data.copy_row_count]);

    useEffect(() => {
        if (compRef?.current?.buckets && app_state.plrRowCalcStatus === 'done') {
            updateCompRef({ buckets: rowData.data.buckets });
        }
    }, [app_state.plrRowCalcStatus]);

    // IF ANY RESTRICTIONS
    let restContainerClass = 'restrictions-container'
    let tableCellClass = '';

    if (isRestrictionOverriden()) {
        restContainerClass = 'restrictions-container restriction-edited user-overriden__';
        tableCellClass = 'restriction-edited user-overriden__ ';
    }
    if (isRecommendedAccepted()) {
        restContainerClass = 'restrictions-container rec-accepted';
        tableCellClass = 'rec-accepted ';
    }
    if (!anyRestrictions) {
        restContainerClass = 'restrictions-container user-overriden__';
        tableCellClass = 'user-overriden__ ';
    }
    if (rowData.data.processing || rowData.data.recalculating) {
        tableCellClass += ' disabled ';
    }
    if (isPrevUserOverriden()) {
        restContainerClass += ' prev-user-overriden';
        tableCellClass += ' prev-user-overriden ';
    }
    tableCellClass += " restrictons-" + type
    if (rowData.data.processing) {
        return (
            <TableCell className={`${tableCellClass} col-cur-restrictions`} style={cellStyle}><Skeleton variant="rounded" height={18} /></TableCell>
        )
    }
    // HANDLE IF ROW TYPE IS BUCKET/RATE_PLAN
    // IF ROOM TYPE IS NOT SUPOORTED
    if (!isRoomTypeSupported) {
        return (<TableCell className={`${tableCellClass} col-cur-restrictions`} style={cellStyle}><Box className='restrictions-container no-supported-rt'> - tt</Box></TableCell>);
    }
    // IF NOT ANY RESTRICTIONS
    if (!anyRestrictions) {
        return (<TableCell className={`${tableCellClass} col-cur-restrictions`} style={cellStyle} onMouseEnter={() => { setShowCopyMenu(true) }} onMouseLeave={() => { setShowCopyMenu(false) }}>
            <Box className='restrictions-container no-restrictons'>
                {jsx_current(false)}
                {roomData?.restrictions.user_override}
                {jsx_addRestrictions}
                {modalOpen && jsx_editRestrictionPopup}
            </Box></TableCell>);
    }

    if (!isRecommendedAccepted() && !isRestrictionOverriden()) {

        return (<TableCell className={`${tableCellClass} col-cur-restrictions`} style={cellStyle} onMouseEnter={() => { setShowCopyMenu(true) }} onMouseLeave={() => { setShowCopyMenu(false) }}>
            <Box className={restContainerClass} onClick={handleCurrentRestrictionsClick}>
                {/* Show "Add Restrictions" button only if there are no current restrictions */}
                {hasCurrent && displayValue.length ? jsx_current() : ''}
                {!displayValue.length && jsx_addRestrictions}
                {hasRecommended() ? jsx_recommended : ''}

            </Box>
            {modalOpen && jsx_editRestrictionPopup}
        </TableCell>)
    }

    if (isRecommendedAccepted()) {
        return (<TableCell className={`${tableCellClass} col-cur-restrictions`} style={cellStyle}>
            <Box className={restContainerClass}>
                {/* Show "Add Restrictions" button only if there are no current restrictions */}
                {hasCurrent && hasRecommended() ? jsx_current_strikedoff : ''}
                {displayValue.length ? jsx_current() : '-'}
                {modalOpen && jsx_editRestrictionPopup}
            </Box></TableCell>)
    }
    if (isRestrictionOverriden()) {
        return (<TableCell className={`${tableCellClass} col-cur-restrictions`} style={cellStyle} onMouseEnter={() => { setShowCopyMenu(true) }} onMouseLeave={() => { setShowCopyMenu(false) }}>
            <Box className={restContainerClass} onClick={handleCurrentRestrictionsClick}>
                {/* Show "Add Restrictions" button only if there are no current restrictions */}
                {jsx_current()}
                {!displayValue.length && jsx_addRestrictions}
                {hasRecommended() && jsx_recommended}
                {modalOpen && jsx_editRestrictionPopup}
            </Box>
            {modalOpen && jsx_editRestrictionPopup}
        </TableCell>)
    }
};

const RestrictionsToolTip = memo((props) => {
    let houseItems = props.chipArrAll;
    let restrictionChip = [];
    let { ratePlanCode, roomTypeCode, roomTypeRestdata, openToolTip, closeToolTip,
        toolTipOpen } = props; //props.roomTypeRestdata;  we need to open this when we nee dto show Room type restrictions

    const [open, setOpen] = useState(false); //Boolean(toolTipOpen);
    const [anchorEl, setAnchorEl] = useState(null); //Boolean(toolTipOpen);

    const handleClose = (event) => {
        setAnchorEl(null);
        setOpen(false);
        // closeToolTip(event);
    };
    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen(true);
        openToolTip();
    };

    roomTypeRestdata.forEach((item, k) => {
        let restClassName = "btn-";
        if (item.toLowerCase().includes("cta")) restClassName += 'cta';
        if (item.toLowerCase().includes("ctd")) restClassName += 'ctd';
        if (item.toLowerCase().includes("mx")) restClassName += 'max_los';
        if (item.toLowerCase().includes("mn")) restClassName += 'min_los';
        if (item.toLowerCase().includes("cls")) restClassName += 'close';

        restrictionChip.push(<div className={"chip " + restClassName}>{item}</div>);
    });

    const [arrowTop, setArrowTop] = React.useState("50%");

    React.useEffect(() => {
        if (!anchorEl) return;

        setTimeout(() => {
            const menuElement = document.querySelector('.rateplan-box');
            const menuHeight = menuElement?.offsetHeight || 200;
            const anchorRect = anchorEl.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            const spaceBelow = windowHeight - anchorRect.top;
            const spaceAbove = anchorRect.top;
            const diff = menuHeight / 2 - spaceBelow;

            let newArrowTop = "50%";

            // If the popover is near the top, move the arrow up
            if (spaceAbove < menuHeight / 2) {
                newArrowTop = `${Math.max(25, (spaceBelow / menuHeight) * 100)}%`;
            }
            // If the popover is near the bottom, move the arrow down
            else if (spaceBelow < menuHeight / 2) {
                newArrowTop = diff > 35 ? "70%" : diff > 30 ? "65%" : diff > 25 ? "60%" : diff > 20 ? "58%" : diff > 15 ? "54%" : diff > 5 ? "50%" : "50%";
            }

            console.log("newArrowTop", newArrowTop);
            setArrowTop(newArrowTop);
        }, 0);
    }, [anchorEl, open]);

    // LRV-1134 START
    const [position, setPosition] = useState('left');
    useEffect(() => {
        if (anchorEl) {
            const anchorRect = anchorEl.getBoundingClientRect();
            const viewportWidth = window.innerWidth;
            const spaceLeft = anchorRect.left;
            const spaceRight = viewportWidth - anchorRect.right;

            // If space on left is greater than 300px, show on left; else right
            if (spaceLeft > 600) {
                setPosition('left');
            } else {
                setPosition('right');
            }
        }
    }, [anchorEl]);
    // LRV-1134 END

    return (
        <div className='restrictions-details'>
            <div
                aria-owns={open ? 'mouse-over-popover' : undefined}
                aria-haspopup="true"
                //onClick={handleClose}
                //onMouseEnter={handleOpen}
                // onClick={handleOpen}
                style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#606060" viewBox="0 0 256 256"><path d="M144,128a16,16,0,1,1-16-16A16,16,0,0,1,144,128ZM60,112a16,16,0,1,0,16,16A16,16,0,0,0,60,112Zm136,0a16,16,0,1,0,16,16A16,16,0,0,0,196,112Z"></path></svg>
            </div>
            {/* LRV-1134 START */}
            <Popover
                className='restrictions-details'

                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        ml: position === 'left' ? '-4px' : '0px',
                        mr: position === 'right' ? '-4px' : '0px',
                        width: 'max-content',
                        position: 'relative',
                        overflow: 'visible',
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            left: position === 'right' ? '-11px' : 'unset',
                            right: position === 'left' ? '-11px' : 'unset',
                            top: '50%',
                            width: 0,
                            height: 0,
                            borderTop: '9px solid transparent',
                            borderBottom: '9px solid transparent',
                            borderLeft: position === 'left' ? '11px solid #F8F9FA' : 'none',
                            borderRight: position === 'right' ? '11px solid #F8F9FA' : 'none',
                            transform: 'translateY(-50%)',
                            filter: 'drop-shadow(-5px -4px 16px rgba(0, 0, 0, 0.2))',
                            zIndex: 1
                        }
                    },
                }}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: position,
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: position === 'left' ? 'right' : 'left',
                }}
            >
                {/* LRV-1134 END */}

                <Box className='restriction-box'>
                    <Box className='restriction-box-title'>Restrictions</Box>
                    <Box sx={{ m: .5, overflow: "auto", maxHeight: 170 }}>
                        <TableContainer sx={{}}>
                            <Table sx={{}}>
                                <TableHead>
                                    <TableRow className='restriction-table-row' sx={{ '& td, & th': { pt: .5, pb: .2, borderBottom: 1 } }}>
                                        <TableCell className='table-heading' sx={{}}>Rate Plan</TableCell>
                                        <TableCell className='table-heading'>Room Type</TableCell>
                                        <TableCell className='table-heading'>Restriction</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ overflowX: "hidden", overflowY: "auto" }}>
                                    {houseItems.length > 0 && (<TableRow
                                        sx={{ 'td, & th': { border: 0, p: 1, pb: 0, fontSize: 12, color: "#333333" } }} // LRV-1134
                                    //sx={{ '&:last-child td, &:last-child th': { border: 0 }, '& td, & th': { border: 0, pt: .6, pb: .8, fontSize: 12, color: "#333333" } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            {ratePlanCode || ""}
                                        </TableCell> <TableCell component="th" scope="row">
                                            {roomTypeCode || ""}
                                        </TableCell> <TableCell component="th" scope="row">
                                            {restrictionChip}
                                        </TableCell>
                                    </TableRow>)}
                                </TableBody>
                            </Table></TableContainer>
                    </Box>
                </Box>
            </Popover>
        </div>
    );
});